import { Navigate, useParams } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useHub } from "@/components/AppShell";
import { canSee, findItem, SOON_COPY } from "@/lib/nav";
import { NoAccess } from "@/components/common";

export default function ComingSoon() {
  const { hub } = useHub();
  const params = useParams();
  const found = findItem(params["*"]);
  if (!found || !found.item.comingSoon) return <Navigate to={`/h/${hub.id}/home`} replace />;
  const { group, item } = found;
  if (!canSee(group.section, hub)) return <NoAccess />;
  const rgb = group.glowRgb;
  return (
    <div className="relative mx-auto mt-6 max-w-2xl overflow-hidden rounded-3xl border p-10 text-center sm:p-14 q-rise" data-testid="coming-soon-page"
      data-section={group.label.toLowerCase()} style={{ borderColor: `rgba(${rgb},0.3)`, background: `radial-gradient(circle at 50% 0%, rgba(${rgb},0.16), transparent 60%)`, boxShadow: `0 0 50px rgba(${rgb},0.12)` }}>
      <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-3xl" style={{ background: `rgba(${rgb},0.14)`, boxShadow: `inset 0 0 0 1px rgba(${rgb},0.45), 0 0 34px rgba(${rgb},0.35)` }}>
        <item.Icon className="h-9 w-9" style={{ color: `rgb(${rgb})`, filter: `drop-shadow(0 0 8px rgba(${rgb},0.8))` }} />
      </span>
      <div className="mt-6 text-[10px] font-black uppercase tracking-[0.22em]" style={{ color: `rgb(${rgb})` }}>{group.label}</div>
      <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-q-text" data-testid="coming-soon-item">{item.label}</h1>
      <p className="mt-4 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-black uppercase tracking-[0.18em]" data-testid="coming-soon-title"
        style={{ color: `rgb(${rgb})`, background: `rgba(${rgb},0.12)` }}>
        <Sparkles className="h-3.5 w-3.5" /> Coming soon
      </p>
      <p className="mx-auto mt-5 max-w-md text-q-muted">{SOON_COPY[item.id]}</p>
    </div>
  );
}
